import * as actionTypes from '../actions/actionTypes';

const initialState = {
    activities: [],
    isActivitySearched: false,
    selectEventActivityLog: null,
    activityLogUserId: null,
    activityLogPageNumber: 1,
    activityLogSearchState: null,
    error: null,
    showSpinner: false,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH_ACTIVITY_LOG:
            return{
                ...state,
                activities: action.response,
                hideResult: false
            }
        case actionTypes.IS_ACTIVITY_SEARCHED:
            return{
                ...state,
                isActivitySearched: action.response
            }
        case actionTypes.SELECT_EVENT_ACTIVITY_LOG:
            return{
                ...state,
                selectEventActivityLog: action.response
            }
        case actionTypes.ACTIVITY_LOG_USERID:
            return{
                ...state,
                activityLogUserId: action.response
            }
        case actionTypes.ACTIVITY_LOG_SEARCH_STATE:
            return{
                ...state,
                activityLogSearchState: action.response
            }
        case actionTypes.ACTIVITY_LOG_PAGE_NUMBER:
            return{
                ...state,
                activityLogPageNumber: action.response
            }      
        case actionTypes.SET_ERROR:
            return {
                ...state,
                error: action.error
            }  
        case actionTypes.SEARCH_ACTIVITY_NOT_FOUND:
            return{
                ...state,
                error: {message:"No Activity Logs found for the search."},
                hideResult: true
            }
        case actionTypes.SEARCH_ACTIVITY_FAILURE: 
            return{
                ...state,
                error: {message:"Oops!! Something didn't work. Pls try again."}
            }
        case actionTypes.ACTIVITY_LOG_SPINNER:
            return{
                ...state,
                showSpinner: action.response
            }   
        default:
            return state;
    }
}

export default reducer;
